/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Legal_EntityInputs */

const cs_enum_legal_entity = /** @type {(inputs: Enum_Legal_EntityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Právnická osoba`)
};

const en_enum_legal_entity = /** @type {(inputs: Enum_Legal_EntityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal entity`)
};

/**
* | output |
* | --- |
* | "Legal entity" |
*
* @param {Enum_Legal_EntityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_legal_entity = /** @type {((inputs?: Enum_Legal_EntityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Legal_EntityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_legal_entity(inputs)
	return cs_enum_legal_entity(inputs)
});